"use strict";

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es6.array.filter");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.for-each");

var _vue = _interopRequireDefault(require("vue"));

var _themeSections = require("@shopify/theme-sections");

require("../../styles/styleguide.scss");

var filters = _interopRequireWildcard(require("./styleguide/utils/filters"));

require("../helpers/polyfill");

require("../helpers/lazysizes");

var _eventBus = _interopRequireDefault(require("../helpers/event-bus"));

require("../sections/cart-drawer");

require("../sections/featured-collection");

require("../sections/image-slider");

var _accordion = _interopRequireDefault(require("../components/accordion"));

var _quantitySelector = _interopRequireDefault(require("../components/quantity-selector"));

var _searchBar = _interopRequireDefault(require("../components/search-bar"));

var _productForm = _interopRequireDefault(require("../components/product-form"));

var _productGallery = _interopRequireDefault(require("../components/product-gallery"));

var _SideNav = _interopRequireDefault(require("./styleguide/components/SideNav.vue"));

var _ContentBlock = _interopRequireDefault(require("./styleguide/components/ContentBlock.vue"));

var _ContentExample = _interopRequireDefault(require("./styleguide/components/ContentExample.vue"));

var _ContentSection = _interopRequireDefault(require("./styleguide/components/ContentSection.vue"));

var _SpecGrid = _interopRequireDefault(require("./styleguide/components/SpecGrid.vue"));

var _SpecGridRow = _interopRequireDefault(require("./styleguide/components/SpecGridRow.vue"));

var _IconGrid = _interopRequireDefault(require("./styleguide/components/IconGrid.vue"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/**
 * Layout: Styleguide
 * -----------------------------------------------------------------------------
 * Core entry file to register and display elements on the styleguide layout
 * - This entire styleguide layout is built by Vue.js
 */

/**
 * Global styleguide helpers.
 */

/**
 * Sections.
 */

/**
 * Components.
 */

/**
 * Vue Components
 */

/**
* Global Frame utils
*/


window.Frame = window.Frame || {};
window.Frame.EventBus = (0, _eventBus["default"])();
/**
 * Register global utility filters.
 */

Object.keys(filters).forEach(function (key) {
  _vue["default"].filter(key, filters[key]);
});
new _vue["default"]({
  el: '#app',
  components: {
    ContentBlock: _ContentBlock["default"],
    ContentExample: _ContentExample["default"],
    ContentSection: _ContentSection["default"],
    IconGrid: _IconGrid["default"],
    SideNav: _SideNav["default"],
    SpecGrid: _SpecGrid["default"],
    SpecGridRow: _SpecGridRow["default"]
  },
  created: function created() {
    var _this = this;

    window.addEventListener('keyup', function (event) {
      if (event.keyCode === 27) {
        _this.$root.$emit('navigation:toggle');
      }
    });
    this.$root.$on('updateView', function () {
      window.dispatchEvent(new window.CustomEvent('resize'));
    });
  },
  mounted: function mounted() {
    /**
     * Initialise sections.
     */
    window.setTimeout(function () {
      return (0, _themeSections.load)('*');
    }, 500);
    /**
     * Initialise components.
     */

    (0, _accordion["default"])('.accordion').init();
    (0, _productForm["default"])({
      container: 'container',
      enableSwatches: true
    }).init();
    (0, _productGallery["default"])().init();
    (0, _quantitySelector["default"])('QuantitySelector-8').init();
    (0, _searchBar["default"])().init();
  }
});